import styled from 'styled-components';

export const Wrapper = styled.div(({ theme }) => ({
  '&[data-focus-visible-added]:focus': {
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}, inset 0px 0px 0px 1px ${theme.colors.primary['500']}`,
    outline: 'none',
    zIndex: 1,
  },
}));
